import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import { BloqueFirmasPdf } from "../Components/PdfComponents/BloqueFirmasPdf";

moment.locale("es");

const layoutTabla = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
};

const layoutRecuadro = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
  vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
};

const texto = (valor) => (valor === undefined || valor === null || valor === "" ? "-" : String(valor));

const fecha = (valor) => (valor ? moment(valor).locale("es").format("LL") : "-");

const redondear = (valor) => Math.round((Number(valor) || 0) * 10000) / 10000;

const tiempoCiclo = (minutos) => {
  const valor = Number(minutos) || 0;
  if (!valor) return "-";
  return valor >= 60 ? `${Math.round((valor / 60) * 100) / 100} h` : `${Math.round(valor * 100) / 100} min`;
};

const encabezado = (titulo, alignment = "center") => ({ text: titulo, style: "tituloTabla", alignment });

const celda = (valor, alignment = "left", extra = {}) => ({ text: texto(valor), style: "textoTabla", alignment, ...extra });

const datoEtiqueta = (etiqueta, valor) => [
  { text: etiqueta, style: "subheader" },
  { text: texto(valor), style: "textoChico" },
];

const filasArbol = (componentes, nivel, cantidadPadre) =>
  (componentes || []).flatMap((componente) => {
    const cantidadProyectada = redondear((Number(componente.cantidad) || 0) * cantidadPadre);
    const medida = componente.medida !== undefined && componente.medida !== null ? ` · ${componente.medida} cm` : "";
    return [
      [
        celda(componente.clave, "left", { margin: [nivel * 8, 0, 0, 0], color: "#555555" }),
        celda(`${componente.descripcion}${componente.matriz ? " (matriz)" : ""}`, "left", { margin: [nivel * 8, 0, 0, 0], color: "#555555" }),
        celda(componente.unidad, "center", { color: "#555555" }),
        celda(`${componente.cantidad}${medida}`, "right", { color: "#555555" }),
        celda(cantidadProyectada, "right", { color: "#555555" }),
        celda("", "center"),
        celda(dineroDisabledMask(componente.costo), "right", { color: "#555555" }),
        celda(dineroDisabledMask(redondear((Number(componente.costo) || 0) * cantidadProyectada)), "right", { color: "#555555" }),
      ],
      ...filasArbol(componente.componentes, nivel + 1, cantidadProyectada),
    ];
  });

const tablaMatrices = (matrices) => {
  if (matrices.length === 0) return [];
  let total = 0;
  const filas = matrices.flatMap((matriz) => {
    const piezas = Number(matriz.piezas) || 0;
    const costoTotal = redondear((Number(matriz.costo) || 0) * piezas);
    total += costoTotal;
    return [
      [
        celda(matriz.clave, "left", { bold: true, fillColor: "#f2f2f2" }),
        celda(matriz.descripcion, "left", { bold: true, fillColor: "#f2f2f2" }),
        celda(matriz.unidad, "center", { fillColor: "#f2f2f2" }),
        celda(piezas, "right", { bold: true, fillColor: "#f2f2f2" }),
        celda(piezas, "right", { fillColor: "#f2f2f2" }),
        celda(tiempoCiclo(matriz.tiempoCiclo), "center", { fillColor: "#f2f2f2" }),
        celda(dineroDisabledMask(matriz.costo), "right", { fillColor: "#f2f2f2" }),
        celda(dineroDisabledMask(costoTotal), "right", { bold: true, fillColor: "#f2f2f2" }),
      ],
      ...filasArbol(matriz.componentes, 1, piezas),
    ];
  });
  return [
    { text: "Matrices", style: "tableHeaderIzquierda", margin: [0, 10, 0, 5] },
    {
      style: "tablaSinMargen",
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: ["14%", "30%", "8%", "10%", "9%", "8%", "10%", "11%"],
        body: [
          [
            encabezado("Clave"),
            encabezado("Matriz / insumo"),
            encabezado("Unidad"),
            encabezado("Cantidad"),
            encabezado("Cant. proy."),
            encabezado("T. ciclo"),
            encabezado("Costo"),
            encabezado("Costo total"),
          ],
          ...filas,
          [
            { text: "Total", style: "subheader", colSpan: 7, alignment: "right" },
            {}, {}, {}, {}, {}, {},
            { text: dineroDisabledMask(total), style: "subheader", alignment: "right" },
          ],
        ],
      },
      layout: layoutTabla,
    },
  ];
};

const tablaMateriales = (materiales) => {
  const lista = (materiales || []).filter((m) => m && (m.descripcion || m.procesos || m.caracteristicas || m.cantidad));
  if (lista.length === 0) return [];
  return [
    { text: "Datos del material solicitado", style: "tableHeaderIzquierda", margin: [0, 10, 0, 5] },
    {
      style: "tablaSinMargen",
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: ["5%", "31%", "14%", "28%", "22%"],
        body: [
          [encabezado("#"), encabezado("Material solicitado"), encabezado("Cantidad"), encabezado("Procesos"), encabezado("Características del material")],
          ...lista.map((m, indice) => [
            celda(indice + 1, "center"),
            celda(m.descripcion),
            celda(m.cantidad === undefined || m.cantidad === null ? "" : `${m.cantidad} ${m.unidad || ""}`.trim(), "right"),
            celda(m.procesos),
            celda(m.caracteristicas),
          ]),
        ],
      },
      layout: layoutTabla,
    },
  ];
};

const tablaExtras = (extras) => {
  if (extras.length === 0) return [];
  return [
    { text: "Extras", style: "tableHeaderIzquierda", margin: [0, 10, 0, 5] },
    {
      style: "tablaSinMargen",
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: ["16%", "38%", "12%", "12%", "22%"],
        body: [
          [encabezado("Clave"), encabezado("Insumo"), encabezado("Unidad"), encabezado("Cantidad"), encabezado("Notas")],
          ...extras.map((e) => [celda(e.clave), celda(e.descripcion), celda(e.unidad, "center"), celda(e.cantidad, "right"), celda(e.notas)]),
        ],
      },
      layout: layoutTabla,
    },
  ];
};

const preCotizacionIngenieriaPdf = (values) => {
  const preCotizacion = values?.preCotizacion || {};
  const empresa = values?.empresa || {};
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const tieneLogo = !!empresa?.logo?.base64Completa;
  const folio = `${preCotizacion.serie || ""} - ${preCotizacion.numero || ""}`;
  const suministra = [preCotizacion.materialPropio && "La empresa", preCotizacion.materialPorCliente && "El cliente"].filter(Boolean).join(" y ");
  const entrega = { recoleccion: "Recolección (cliente)", entrega: "Entrega (chofer)" }[preCotizacion.recoleccionOEntrega];

  const cabecera = HeaderEmpresaCard(empresa, mostrarRegimen, false, {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: "N° Pre Cotización:", style: "subheader", alignment: "center" }],
        [{ text: folio, style: "textoChico", alignment: "center" }],
        [{ text: "Fecha de solicitud:", style: "subheader", alignment: "center" }],
        [{ text: fecha(preCotizacion.fechaSolicitud || preCotizacion.createdAt), style: "textoChico", alignment: "center" }],
        [{ text: "Fecha compromiso:", style: "subheader", alignment: "center" }],
        [{ text: fecha(preCotizacion.fechaCompromiso), style: "textoChico", alignment: "center" }],
        ...(preCotizacion.urgente ? [[{ text: "URGENTE", style: "subheader", color: "#c0392b", alignment: "center" }]] : []),
      ],
    },
    layout: "noBorders",
  });
  if (!tieneLogo) cabecera[0] = { border: [false, false, false, false], text: "" };

  const dd = {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["20%", "50%", "30%"],
          layout: "noBorders",
          body: [cabecera],
        },
      },
      { text: "Pre Cotización N° " + folio, style: "tableHeaderIzquierda" },
      {
        style: "tableExample",
        table: {
          widths: ["50%", "50%"],
          body: [
            [
              {
                table: {
                  widths: ["35%", "65%"],
                  body: [
                    datoEtiqueta("Nombre de la cotización:", preCotizacion.nombreProyecto),
                    datoEtiqueta("Cliente:", preCotizacion.clienteNombre),
                    datoEtiqueta("Contacto:", preCotizacion.contactoNombre),
                    datoEtiqueta("Teléfono:", preCotizacion.contactoTelefono),
                    datoEtiqueta("Correo:", preCotizacion.contactoCorreo),
                  ],
                },
                layout: "noBorders",
              },
              {
                table: {
                  widths: ["35%", "65%"],
                  body: [
                    datoEtiqueta("Encargado:", preCotizacion.encargadoNombre),
                    datoEtiqueta("Suministra material:", suministra),
                    datoEtiqueta("Programación de entrega:", entrega),
                    datoEtiqueta("Fecha de solicitud:", fecha(preCotizacion.fechaSolicitud)),
                    datoEtiqueta("Fecha compromiso:", fecha(preCotizacion.fechaCompromiso)),
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: layoutRecuadro,
      },
      ...tablaMateriales(preCotizacion.caracteristicasMaterial),
      ...tablaMatrices(preCotizacion.matricesDetalle || []),
      ...tablaExtras(preCotizacion.extrasDetalle || []),
      ...(preCotizacion.notas || preCotizacion.notasCotizacion
        ? [
            { text: "Notas", style: "tableHeaderIzquierda", margin: [0, 10, 0, 5] },
            {
              style: "tablaSinMargen",
              table: {
                widths: ["50%", "50%"],
                body: [
                  [encabezado(empresa?.ordenesMaquila ? "Para la orden de maquila" : "Para la orden de producción"), encabezado("Para la cotización")],
                  [celda(preCotizacion.notas), celda(preCotizacion.notasCotizacion)],
                ],
              },
              layout: layoutTabla,
            },
          ]
        : []),
      BloqueFirmasPdf([{ titulo: "Elaboró", nombre: preCotizacion.encargadoNombre || "" }, { titulo: "Autorizó", nombre: "" }]),
    ],
    images: tieneLogo ? { logo: empresa.logo.base64Completa } : {},
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tablaSinMargen: { margin: [0, 0, 0, 0] },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
      textoChicoData: { fontSize: 6 },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoTabla: { fontSize: 8, italics: false },
    },
    pageSize: "LETTER",
  };

  if (preCotizacion.estado === 2) {
    dd.watermark = { text: "DESHABILITADA", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 90 };
  }

  return dd;
};

export default preCotizacionIngenieriaPdf;
